import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { Seo } from "@/components/Seo";
import { PROJECTS } from "@/data/projects";

const FILTERS = ["Alle", "Kozijnen", "Deuren", "Schuifpuien"];

export default function Projecten() {
  const [active, setActive] = useState("Alle");
  const shown = active === "Alle" ? PROJECTS : PROJECTS.filter((p) => p.cat === active);

  return (
    <main data-testid="projecten-page" className="bg-white">
      <Seo
        title="Projecten & Gerealiseerd Werk | DEKO Kozijnen"
        description="Bekijk recent gerealiseerde projecten van DEKO Kozijnen: kunststof kozijnen, deuren en schuifpuien geplaatst in Groningen, Friesland en Drenthe."
      />
      <section className="pt-40 pb-14 mx-auto max-w-[1440px] px-6 md:px-10">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] text-[#222]/40">Projecten</span>
          <h1 className="font-display font-extrabold text-4xl sm:text-6xl text-[#2F3438] mt-5 max-w-3xl leading-tight">Werk dat voor zich spreekt.</h1>
        </Reveal>
        <div className="mt-10 flex flex-wrap gap-3">
          {FILTERS.map((f) => (
            <button key={f} onClick={() => setActive(f)} data-testid={`filter-${f.toLowerCase()}`}
              className={`text-sm px-5 py-2.5 rounded-sm border transition-colors duration-300 ${active === f ? "bg-[#2F3438] border-[#2F3438] text-white" : "border-[#E0E0DE] text-[#222]/60 hover:border-[#2F3438]"}`}>
              {f}
            </button>
          ))}
        </div>
      </section>

      <section className="pb-28 mx-auto max-w-[1440px] px-6 md:px-10">
        <motion.div layout className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="projects-grid">
          <AnimatePresence mode="popLayout">
            {shown.map((p) => (
              <motion.div key={p.id} layout initial={{ opacity: 0, scale: 0.97 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.97 }} transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }} data-testid={`project-${p.id}`} className="group">
                <div className="relative overflow-hidden rounded-sm aspect-[4/5] bg-[#ECECEA]">
                  <img src={p.img} alt={p.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="flex items-center justify-between mt-4">
                  <div>
                    <div className="text-xs uppercase tracking-widest text-[#222]/40">{p.cat}</div>
                    <h3 className="font-display font-semibold text-lg text-[#2F3438] mt-1">{p.title}</h3>
                  </div>
                  <span className="text-sm text-[#222]/40">{p.place}</span>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </section>
    </main>
  );
}
